"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteLayout = deleteLayout;
exports.getComponentList = getComponentList;
exports.getDeployLocation = getDeployLocation;
exports.getDictCode = getDictCode;
exports.getIspCodeDictList = getIspCodeDictList;
exports.saveOrUpdateCustom = saveOrUpdateCustom;
var _request = _interopRequireDefault(require("@/utils/request"));
/* 获取岸端船端判断 */
function getDeployLocation() {
  return (0, _request.default)({
    url: '/sitceb-system-service/common/getDeployLocation',
    method: 'get'
  });
}
/* 获取数据字典 */
function getIspCodeDictList() {
  var data = sessionStorage.getItem('SET_DICTIONARY_ISP') ? JSON.parse(sessionStorage.getItem('SET_DICTIONARY_ISP')) : null;
  if (data) {
    return new Promise(function (resolve, reject) {
      if (data) {
        resolve(data);
      } else {
        reject('没有数据字典');
      }
    });
  } else {
    return (0, _request.default)({
      url: "http://172.16.7.108:8888/cdmCodedict/getIspCodeDictList",
      method: "get"
    });
  }
}

/* 获取数据字典 */
function getDictCode(query) {
  return (0, _request.default)({
    url: '/sitceb-system-service/dict/getMultiDictCode',
    method: 'get',
    params: query
  });
}

/* 表格相关配置- 获取组件列表 */
function getComponentList(data) {
  return (0, _request.default)({
    url: '/sitceb-system-service/sysPageComponent/getComponentList',
    method: 'post',
    data: data
  });
}
/* 表格相关配置- 保存组件配置 */
function saveOrUpdateCustom(data) {
  return (0, _request.default)({
    url: '/sitceb-system-service/sysPageComponent/saveOrUpdateCustom',
    method: 'post',
    data: data
  });
}
/* 表格相关配置- 删除组件配置 */
function deleteLayout(data) {
  return (0, _request.default)({
    url: '/sitceb-system-service/sysPageComponent/deleteLayout',
    method: 'post',
    data: data
  });
}